import { AfterViewInit, Component, Input, OnInit, Optional, Self, ViewChild } from '@angular/core';
import { ControlValueAccessor, FormControl, NgControl } from '@angular/forms';
import { NgOtpInputComponent, NgOtpInputConfig } from 'ng-otp-input';
import { SharedModule } from '@app/shared/shared.module';

const INCOMPLETE_CODE_ERRORS = ['required', 'minlength'];

@Component({
  selector: 'c-otp-input',
  templateUrl: './otp.component.html',
  styleUrl: './otp.component.scss',
  imports: [SharedModule],
  host: {
    '[class.otp--invalid]': 'showInvalid',
  },
})
export class OtpInputComponent<T = any> implements OnInit, AfterViewInit, ControlValueAccessor {
  @Input() label: string;
  @Input() length = 6;

  /**
   * Makes the boxes read-only while leaving the bound control enabled, so it
   * keeps its validity. Disabling the control itself would turn it DISABLED.
   */
  @Input() set locked(locked: boolean) {
    this._locked = locked;
    this.otpInput?.setDisabledState(locked);
  }

  @ViewChild(NgOtpInputComponent) private otpInput?: NgOtpInputComponent;

  private _locked = false;

  config: NgOtpInputConfig;

  get control() {
    return this.ngControl?.control as FormControl;
  }

  /**
   * ng-otp-input autofocuses and marks the control touched on focus-in, so `touched` is set before the
   * user typed anything. An incomplete code isn't an error either; only other errors (e.g. a rejected code) are.
   */
  get showInvalid(): boolean {
    const errors = this.control?.errors;
    return !!errors && Object.keys(errors).some((key) => !INCOMPLETE_CODE_ERRORS.includes(key));
  }

  constructor(@Optional() @Self() public ngControl: NgControl) {
    if (this.ngControl) {
      this.ngControl.valueAccessor = this;
    }
  }

  ngOnInit(): void {
    this.config = {
      length: this.length,
      allowNumbersOnly: true,
      inputClass: 'otp__digit',
    };
  }

  ngAfterViewInit(): void {
    if (this._locked) {
      this.otpInput?.setDisabledState(true);
    }
  }

  writeValue(value: any): void {}

  onChange = (value: T) => {};
  onTouched = () => {};

  registerOnChange(fn: (value: T) => void): void {
    this.onChange = fn;
  }

  // eslint-disable-next-line @typescript-eslint/ban-types
  registerOnTouched(fn: () => {}): void {
    this.onTouched = fn;
  }
}
